import { render, staticRenderFns } from "./policyForm.vue?vue&type=template&id=69868990&scoped=true"
import script from "./policyForm.vue?vue&type=script&lang=js"
export * from "./policyForm.vue?vue&type=script&lang=js"
import style0 from "./policyForm.vue?vue&type=style&index=0&id=69868990&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69868990",
  null
  
)

export default component.exports